<template>
  <div class="bottomimg">
    <div class="bottom-img">
            <img src='@/assets/companyprofilepic/bottomimg.png' alt="">
          </div>
  </div>
</template>

<script>
export default {
  name: "BottomImg",
}

</script>

<style scoped>
.bottom-img {
  position: relative;
  width: auto;
  height: 400px; 
  background: radial-gradient(circle, 
              #fff 0%,
              #fff 30%,
              #eaeaea 30%,
              #eaeaea 60%,
              #fff 60%,
              #fff 90%,
              transparent 90%);
  display: flex;
  justify-content: center;
  align-items: center;
}

.bottom-img img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  display: block;
  margin: 0 auto;
}

.bottomimg {
  background-color: #eaeaea;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-block: 30px;
}
</style>


// WEBPACK FOOTER //
// src/views/home/products/BottomImg.vue